/* eslint-disable */
import { createRouter, createWebHistory } from "vue-router";
import routes from "./routes";
import cookies from "vue-cookies";

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      const element = document.querySelector(to.hash);
      if (element) {
        return {
          el: to.hash,
          behavior: "smooth",
        };
      }
    }
    return {
      top: 0,
    };
  },
});

const urlParams = new URLSearchParams(window.location.search);

const utm_source = urlParams.get("utm_source") || cookies.get("utm_source");
const utm_medium = urlParams.get("utm_medium") || cookies.get("utm_medium");
const utm_campaign =
  urlParams.get("utm_campaign") || cookies.get("utm_campaign");
const utm_term = urlParams.get("utm_term") || cookies.get("utm_term");
const utm_content = urlParams.get("utm_content") || cookies.get("utm_content");
const referred_from =
  urlParams.get("referred_from") || cookies.get("referred_from");

if (utm_source)
  cookies.set("utm_source", utm_source, "30d", "/", ".atiyehiraniancf.com");

if (utm_medium)
  cookies.set("utm_medium", utm_medium, "30d", "/", ".atiyehiraniancf.com");

if (utm_campaign)
  cookies.set("utm_campaign", utm_campaign, "30d", "/", ".atiyehiraniancf.com");

if (utm_term)
  cookies.set("utm_term", utm_term, "30d", "/", ".atiyehiraniancf.com");

if (utm_content)
  cookies.set("utm_content", utm_content, "30d", "/", ".atiyehiraniancf.com");

if (referred_from)
  cookies.set(
    "referred_from",
    referred_from,
    "30d",
    "/",
    ".atiyehiraniancf.com"
  );

router.beforeEach((to, from, next) => {
  const path = to.path.toLowerCase();

  if (path.startsWith("/authentication")) {
    window.location.href = `https://my.atiyehiraniancf.com${to.fullPath}`;
    return;
  }
  if (path.startsWith("/au")) {
    window.location.href = `https://my.atiyehiraniancf.com${to.fullPath}`;
    return;
  }
  if (path.startsWith("/register")) {
    window.location.href = `https://my.atiyehiraniancf.com${to.fullPath}`;
    return;
  }
  if (path.startsWith("/r/")) {
    window.location.href = `https://my.atiyehiraniancf.com${to.fullPath}`;
    return;
  }
  if (path.startsWith("/dashboard")) {
    window.location.href = `https://my.atiyehiraniancf.com${to.fullPath}`;
    return;
  }

  next();
});

export default router;
